import { Link } from "react-router-dom";
import { tr } from "../../lib/i18n";

export default function NotFoundPage() {
  return (
    <section className="public-container" style={{ padding: "120px 24px", minHeight: "50vh" }} data-testid="not-found-page">
      <div className="eyebrow" style={{ marginBottom: 12 }}>404</div>
      <h1 style={{ fontSize: "clamp(32px, 4vw, 48px)", fontWeight: 500, margin: "0 0 12px" }}>{tr("x.page_not_found")}</h1>
      <p style={{ color: "var(--pub-ink-soft)", maxWidth: 520, margin: "0 0 28px" }}>{tr("x.page_not_found_help")}</p>
      <Link to="/" className="pub-cta primary" data-testid="not-found-home">{tr("x.back_to_home")}</Link>
    </section>
  );
}
